/**
 * this page was added to automatically redirect the user to the  sign in page
 * when the user clicks on a find out more link on staq.io
 */
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import { HeadWrapper } from '../../elements';
import { keycloak } from '../../keycloak-config';

function AuthVerification(props) {
  useEffect(() => {
    if (!keycloak.authenticated) {
      keycloak.login();
    }
    props.history.push('/');
  }, []);

  return (
    <HeadWrapper
      href={`https://developer.staq.io/realms`}
      title="Login - Staq Developer Portal"
      description="Log in to manage and explore innovative digital banking solutions. Enter your journey with Staq."
    />
  );
}

export default withRouter(AuthVerification);
